<template>
    <jet-authentication-card>
        <template #logo>
            <div class="flex flex-row justify-center">

                <jet-authentication-card-logo />

                <!-- <div v-if="invitation && invitation.team.team_logo_url != ''"
                class="ml-5">
                    <vue-feather type="plus" class="w-6 h-6"></vue-feather>
                </div>
                <div v-if="invitation && invitation.team.team_logo_url != ''"
                    class="ml-5">
                    <img :src="invitation.team.team_logo_url"
                        alt="logo"
                        class="flex w-16" />
                </div> -->
            </div>
        </template>

        <template #message>
            <div v-if="invitation" class="text-center mt-12 mb-1 text-xl text-gray-700">
                Welcome!<br />
                You’ve been invited to join <span class="font-bold">{{ invitation.team.name }}</span> team on {{
                    $page.props.app_name }}.
                <br />

                <span v-if="!existing_user">Complete this form and you’ll be set.<br /></span>
                <span v-if="!existing_user" class="text-3xl">👇</span>
            </div>
        </template>

        <!-- <jet-validation-errors class="mb-4"  /> -->

        <div class="my-6 max-w-md mx-auto text-center" v-if="existing_user">
            A user with this email already exists.<br />
            <a :href="route('login', { email: form.email })"
                class="underline text-birdie-blue hover:text-gray-900">Click here
                to sign-in</a><br />or ask for
            a new
            invitation with
            another email.
        </div>

        <form @submit.prevent="submit" v-else>


            <!-- <div class="mt-4" v-if="existing_user">
                <jet-label for="email" value="Email" />
                <jet-input id="email" type="hidden" class="mt-1 block w-full" v-model="form.email" required />
                <div class="border-gray-300 rounded-md shadow-sm mt-1 block w-full py-2 px-3 border text-gray-500">{{
                    form.email
                }}</div>
                <jet-input-error :message="form.errors.email" class="mt-2" />
            </div> -->
            <div>
                <jet-label for="email" value="Invitation Email" />
                <jet-input v-if="false" id="email" type="email" class="mt-1 block w-full" v-model="form.email"
                    required />
                <div
                    class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full py-2 px-3 border text-gray-500">
                    {{ form.email }}
                </div>
                <jet-input-error :message="form.errors.email" class="mt-2" />
            </div>

            <div class="mt-4">
                <jet-label for="name" value="Your Name" />
                <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus
                    autocomplete="name" placeholder="John Doe" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
            </div>

            <div class="mt-4" v-if="false">
                <jet-label for="password" value="Password" />
                <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required
                    autocomplete="new-password" />
                <jet-input-error :message="form.errors.password" class="mt-2" />
            </div>

            <div class="mt-4" v-if="false">
                <jet-label for="password_confirmation" value="Confirm Password" />
                <jet-input id="password_confirmation" type="password" class="mt-1 block w-full"
                    v-model="form.password_confirmation" required autocomplete="new-password" />
            </div>

            <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
                <jet-label for="terms">
                    <div class="flex items-center">
                        <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />

                        <div class="ml-2">
                            I agree to the <a :href="'https://www.' + domain + '/legal#terms'" target="_blank"
                                :title="app_name + ' Terms of service'"
                                class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and <a
                                :href="'https://www.' + domain + '/legal'" target="_blank"
                                title="{{ $page.props.app_name }} Privacy Policy"
                                class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a>
                        </div>
                    </div>
                </jet-label>
            </div>

            <div class="flex items-center justify-end mt-4">
                <inertia-link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                    Already registered?
                </inertia-link>

                <jet-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Register
                </jet-button>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetCheckbox from "@/Jetstream/Checkbox"
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import moment from 'moment-timezone';

export default {
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors, JetInputError
    },

    created() {
        this.moment = moment;
        this.form.timezone = this.moment.tz.guess()
        //console.log(this.invitation)
        if (this.invitation) {
            if (this.invitation.email) {
                this.form.email = this.invitation.email
            }
        }
        if (this.existing_user) {
            if (this.existing_user.name) {
                this.form.name = this.existing_user.name
            }
            this.form.existing_user_id = this.existing_user.id
        }
    },

    props: {
        invitation: {
            type: Object,
            default: {},
        },
        existing_user: {
            type: Object,
            default: null,
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                name: '',
                email: '',
                password: '12345678_dummy',
                password_confirmation: '12345678_dummy',
                terms: false,
                team: this.invitation ? this.invitation.team.id : 0,
                role: this.invitation ? this.invitation.role : "",
                invitation_id: this.invitation ? this.invitation.id : 0,
                timezone: '',
                existing_user_id: 0
            }),
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name
        }
    },

    methods: {
        submit() {

            this.form.post(this.route('team-invitations.register'), {
                errorBag: 'invitation',
                preserveScroll: true,
                onSuccess: () => {
                    // this.$inertia.visit(route('quick_start'))
                },
            })
        }
    }
}
</script>
